<template>
  <div class="smart-detail">
    <div style="display: flex; flex-wrap: wrap">
      <div v-for="(i, k) in viewOption" :key="k">
        <div :style="props.itemStyle">
          <div class="title" style="margin-right: 5px">{{ i.label }}:</div>
          <div class="content">
            <smart-render :render="getDetail" :column="i" :data="data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="tsx" name="SmartDetail">
import type { Values } from '../../common'
import { computed, inject, type PropType } from 'vue'
import { filterDetailOption } from '../smart-crud/utils'
import SmartRender from './render'
import { moneyFormat } from '../utils/tools'

const lang = inject('lang')

const props = defineProps({
  option: {
    type: Object as PropType<Values>,
    default: () => ({})
  },
  data: {
    type: Object as PropType<Values>,
    default: () => ({})
  },
  itemStyle: {
    type: String,
    default: 'width:24%;margin-right:15px;'
  }
})

const sfo = filterDetailOption(props.option.column, lang) as Record<any, any>[]

const viewOption = computed(() => {
  return sfo.filter((i: Record<any, any>) => i.viewDisplay !== false) as Record<any, any>[]
})

const getDetail = (i: Values, data: Values) => {
  const text = data[i.prop]

  if (i.render) {
    return i.render(text, data)
  }

  if (i.type === 'text') {
    if (i.moneyFormat === true) {
      const val = data[i.viewProp || i.prop]
      const txt = moneyFormat(val)
      if (val < 0) {
        return <span style="color: red">{txt}</span>
      } else {
        return txt
      }
    }
    return data[i.viewProp || i.prop]
  }

  if (['radio-button', 'select', 'radio'].includes(i.type) && i.dicData) {
    const enumMap = i.dicData.reduce((acc: any, item: any) => {
      acc[item.value] = item.label
      return acc
    }, {})

    const iconMap = i.dicData.reduce((acc: any, item: any) => {
      acc[item.value] = item.enumIcon
      return acc
    }, {})
    const val = enumMap[text] || '-'
    const icon = iconMap[text]
    return (
      <div>
        {icon && <a-badge status={icon} />}
        {val}
      </div>
    )
  }
  return '-'
}
</script>
<style lang="less" scoped>
.smart-detail {
  padding-top: 20px;
}

.content {
  margin-bottom: 10px;
}
</style>
